import React from 'react'
import SubresellersCreateContainer from 'containers/panel/reseller/subresellers-create-container'

const SubresellersCreatePage = () => {
  return (
    <SubresellersCreateContainer/>
  )
}

export default SubresellersCreatePage